import {map} from 'lodash';
import {inlineSchema} from './utils';
import * as Member from './membership';
import * as Product from './product';
import * as Payment from './payment';
import * as Order from './order';
import * as Appointment from './appointment';
import i18n from 'src/i18n';


export default function (model) {
  return {
    transaction_id: {type: 'id', required: true},
    created_at: {type: 'datetime', readonly: true},
    status: {type: 'select', items: ['status.active', 'status.inactive'], default: 'active'},

    'remark.transaction_code': {type: 'label'},
    'remark.notes': {type: 'string', maxlength: 200},

    type: {
      type: 'select',
      readonly: true,
      items: map(Object.keys(i18n.s('type.transaction')), x => 'type.transaction.' + x),
    },
    tags: {type: 'tags'},

    transaction_progress: {
      type: 'select', items: [
        'status.pending', 'status.failed', 'status.success', 'status.waiting_admin_confirm',
      ],
      get readonly() {
        return !model || model.type === 'purchase';
      },
    }, //  update after getting credit card payment charge result

    from: {type: 'schema', schema: Member, readonly: true},
    to: {type: 'schema', schema: Member, readonly: true},

    //  classify transaction:
    //  RECORD SHOULD BE RESISTANT TO CHANGE SO STORE DATA INSTEAD OF REF *****
    //  filled by client and process in server
    products: {
      readonly: true,
      type: 'array',
      itemType: {
        type: 'schema', schema: inlineSchema({
          product: {type: 'schema', required: true, schema: Product}, //  ticket in okcare
          quantity: {type: 'number', validation: {min_value: 1}}, //  no of ticket

          //  serial_no : ( product_id + cusotom_ids)   = ticket_ref_id x
          // product: { type: Schema.Types.ObjectId, ref: 'products', required: true }
          // custom_ids: ['Object_Id'],
          // quantity:


          // value_type: 'cash' // or diamond
          // currency: 'hkd',
          // expiry_date: Date // today() + item.days_to_expiry
          // (optional, when value_type == 'cash')

          //  account_id: '123123-1312-3123-13123',
          // (optional, when value_type == 'cash')
          // coupon_code: [''],
          // pre_calculate_price: 2500,
          // service_user_id: '31231-123123-12312'
        }),
      },
    },

    coupons: [{
      coupon: {},
      quantity: {type: 'number'},
    }],

    currency_type: {
      type: 'select',
      readonly: true,
      items: ['fields.currency.cash_hkd', 'fields.currency.cash_usd'],
    },
    // original_amount: {type: 'number'},
    // discount_amount: {type: 'number'},

    // sub_total: { type: Number }, //  for future development  ( before tax )
    // tax: { type: Number, default: 0 }, //  for future development
    total_amount: {
      type: 'label',
      readonly: true,
    },

    details: {
      hidden: model && model.type == 'caregiver_invoice',
      type: 'schema', schema: inlineSchema({
        payment: {type: 'schema', schema: Payment, external: true},
      }),
    },
    ref: {
      label: 'fields.records',
      type: 'schema', schema: inlineSchema({
        order: {type: 'schema', schema: Order, external: true, readonly: true},
        appointment: {type: 'schema', schema: Appointment, readonly: true},
      }),
    },

  };
}



// WEBPACK FOOTER //
// ./src/schemas/transaction_db.js